import React, { useEffect, useState } from 'react';

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import Image from './Image';

import * as APIS from "../utils/service";
import { randomNumberLength, errorMessage } from "../utils/utils.js";


import { usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import images from '../libs/images';
import consts from '../libs/consts';

export default function GalleryItem({
    item,
    title,
    onClick = () => { },
    like = false,
    setLike = (like) => { }
}) {

    const { user, token, login } = useUser();
    const { closeSignPop } = usePopup();

    const [isLike, setIsLike] = useState(false);

    useEffect(() => {
        setIsLike(like);
    }, [like]);
    return (
        <div
            className='gallery_item'
            style={{ aspectRatio: item?.ratio ? item?.ratio : undefined }}
            onClick={onClick}
        >
            <Image src={item?.src} />
            <div className='title_box'>
                <p>{title}</p>
                <button
                    className={`like_btn ${isLike ? 'on' : ''}`}
                    onClick={e => {
                        e.stopPropagation();
                        setLike(!isLike)
                    }}
                />
            </div>
        </div>

    )
}